import React, { Fragment, useState } from 'react';
import NewsletterSignUpForm from './NewsletterSignUpForm'

const NewsletterSignUpBlock = ({successMessage}) => {
    const [showConfirm, setShowConfirm] = useState(false);

    const onSubmittedForm = () => {
        setShowConfirm(true);
        pushToDataLayer('newsletterSubscriptionSubmit');
    }

    return (
        <Fragment>
            {!showConfirm ? (
                <NewsletterSignUpForm onSubmitted={() => onSubmittedForm()} signupComponentName={"NewsletterSubscriptionBlock"} />
            ) : (
                <div dangerouslySetInnerHTML={ {__html: successMessage} } />
            )}

        </Fragment>
    );
};

export default NewsletterSignUpBlock;
